import Rest from '../Rest'

export default class KnowledgeService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v2/knowledge/items'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  deleteAttachment(id: Number, mediaId: Number) {
    return this.delete(`${id}/files/${mediaId}`)
  }

  getCategories() {
    return this.get('/categories')
  }

  getCategoriesGrid() {
    return this.get('/categories/grid')
  }

  getItemsByCategory(categoryId) {
    return this.get(`/categories/${categoryId}/items`)
  }
}
